import GlList from '@/pages/components/account/gl-invoice/GlList';

export default {
    list: GlList,
};
